import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconDepartment = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M3.855 9.728c0-.1-.081-.182-.182-.182l-1.172-.002v-3.17l3.203-.003 1.38 1.38v2.525c0 .1.08.182.181.182h2.845c.1 0 .182-.082.182-.182v-2.95c0-.1-.082-.181-.182-.181H7.506L6.17 5.809V2.527h3.133v1.11c0 .101.081.182.182.182h2.845c.1 0 .181-.081.181-.181V.688c0-.1-.08-.182-.181-.182H9.485c-.1 0-.182.082-.182.182V1.8H6.17V.364C6.17.163 6.007 0 5.807 0H.364C.163 0 0 .163 0 .364v5.644c0 .2.163.363.364.363l1.41.003v3.17l-.946.002c-.1 0-.181.082-.181.182v2.95c0 .1.081.181.181.181h2.845c.1 0 .182-.081.182-.182zm-2.404.44c-.1 0-.182.082-.182.183v1.704c0 .1.082.181.182.181h1.6c.1 0 .182-.08.182-.181V10.35c0-.1-.082-.182-.182-.182zm6.437-2.4c-.1 0-.182.08-.182.181v1.704c0 .1.081.182.182.182h1.6c.1 0 .181-.081.181-.182V7.95c0-.1-.081-.182-.181-.182zM1.56 1.197c-.2 0-.364.162-.364.363v3.25c0 .2.163.363.364.363h3.048c.201 0 .364-.163.364-.364V1.56c0-.2-.163-.363-.364-.363zm8.546-.069c-.1 0-.181.081-.181.182v1.704c0 .1.081.182.181.182h1.6c.1 0 .182-.082.182-.182V1.311c0-.1-.081-.182-.182-.182z"
      clipRule="evenodd"
    />
  </svg>
)

export default IconDepartment
